__turbopack_context__.v({
  "block": "client-record-visual-module__Ho6STW__block",
  "blockLifted": "client-record-visual-module__Ho6STW__blockLifted",
  "count": "client-record-visual-module__Ho6STW__count",
  "crCount": "client-record-visual-module__Ho6STW__crCount",
  "fieldLabel": "client-record-visual-module__Ho6STW__fieldLabel",
  "fieldList": "client-record-visual-module__Ho6STW__fieldList",
  "fieldValue": "client-record-visual-module__Ho6STW__fieldValue",
  "leftCol": "client-record-visual-module__Ho6STW__leftCol",
  "reveal": "client-record-visual-module__Ho6STW__reveal",
  "revealVisible": "client-record-visual-module__Ho6STW__revealVisible",
  "rightCol": "client-record-visual-module__Ho6STW__rightCol",
  "root": "client-record-visual-module__Ho6STW__root",
  "sideBlock": "client-record-visual-module__Ho6STW__sideBlock",
  "source": "client-record-visual-module__Ho6STW__source",
  "sourceVisible": "client-record-visual-module__Ho6STW__sourceVisible",
});
